import type { GetObligationAssessmentResultByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetObligationAssessmentResultByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationAssessmentResultByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetObligationAssessmentResultByIdArgs = {
  id: string;
};

export const useGetObligationAssessmentResultById = createQueryHook<
  UseGetObligationAssessmentResultByIdArgs,
  GetObligationAssessmentResultByIdResponseRow[],
  GetObligationAssessmentResultByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.obligationAssessmentResult.obligationAssessmentResultById.queryOptions(
      { id }
    ),
  mapTrpcDataToGraphQL: (data) => ({ obligation_assessment_result: data }),
  graphqlDocument: GetObligationAssessmentResultByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
